export default "__VITE_ASSET__9xB8UHan__"